import { Component, OnInit } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICellEditorParams } from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { STATUSES } from '../../work-orders/select-options'
@Component({
  selector: 'app-lading-status-cell-editor',
  templateUrl: './lading-status-cell-editor.component.html',
  styleUrls: ['./lading-status-cell-editor.component.scss']
})
export class LadingStatusCellEditorComponent implements ICellEditorAngularComp, OnInit {
  public params!: ICellEditorParams;
  public ladingStatusForm!: FormGroup;
  public lading_status_options = STATUSES;
  public dateNeededStatuses = [
    'Arrived Shipper', 'Loading Shipper', 'Loaded Shipper',
    'En Route Consignee', 'Arrived Consignee', 'Unloading Consignee',
    'Delivered Consignee'
  ];
  public showDateAndTime = false;
  public timezone_regions: { [key: string]: string } = {
    'America/Toronto': 'ON',
    'America/Vancouver': 'BC',
    'America/Edmonton': 'AB',
    'America/Montreal': 'QC',
    'America/Chicago': 'IL',
    'America/Halifax': 'NS',
    'America/Dawson_Creek': 'BC',
    'America/Regina': 'SK',
    'America/Winnipeg': 'MB',
    'America/Los_Angeles': 'CA',
    'America/New_York': 'NY',
    'America/Detroit': 'MI',
    'America/Thunder_Bay': 'ON',
    'America/St_Johns': 'NL',
    'America/Swift_Current': 'SK',
    'America/Denver': 'CO',
    'America/Indiana/Indianapolis': 'IN',
    'America/Indiana/Knox': 'IN',
    'America/Indiana/Marengo': 'IN',
    'America/Indiana/Petersburg': 'IN',
    'America/Indiana/Tell_City': 'IN',
    'America/Indiana/Vevay': 'IN',
    'America/Indiana/Vincennes': 'IN',
    'America/Indiana/Winamac': 'IN',
    'America/Kentucky/Louisville': 'KY',
    'America/Kentucky/Monticello': 'KY',
    'America/North_Dakota/Beulah': 'ND',
    'America/North_Dakota/Center': 'ND',
    'America/North_Dakota/New_Salem': 'ND',
    'America/Boise': 'ID',
    'America/Whitehorse': 'YT',
    'America/Yellowknife': 'NT',
    'America/Rainy_River': 'ON',
    'America/Dawson': 'YT',
    'America/Rankin_Inlet': 'NU',
    'America/Goose_Bay': 'NL',
    'America/Iqaluit': 'NU',
    'America/Inuvik': 'NT',
    'America/Juneau': 'AK',
    'America/Cambridge_Bay': 'NU',
    'America/Yakutat': 'AK'
  };
  public shipper_timezone: string | null = null;
  public consignee_timezone: string | null = null;
  private lading_uuid: string = '';

  constructor(private fb: FormBuilder, private http: HttpClient) {}

  ngOnInit() {
    // Initialize the form
    this.ladingStatusForm = this.fb.group({
      status: [this.params.value, Validators.required],
      date: [new Date()],
      time: ['00:00'],
      timezone: ['']
    });

    // Fetch timezones if lading_uuid is available
    if (this.lading_uuid) {
      this.fetchTimezones();
    }

    this.onStatusChange();

    // Listen to status changes
    this.ladingStatusForm.get('status')!.valueChanges.subscribe(() => {
      this.onStatusChange();
    });
  }

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.lading_uuid = params.data.lading_uuid; // Get lading_uuid from params
  }

  onStatusChange() {
    const status = this.ladingStatusForm.get('status')!.value;
    this.showDateAndTime = this.dateNeededStatuses.includes(status);

    if (this.showDateAndTime) {
      this.ladingStatusForm.get('date')!.setValidators([Validators.required]);
      this.ladingStatusForm.get('time')!.setValidators([Validators.required]);
      this.ladingStatusForm.get('timezone')!.setValidators([Validators.required]);
    } else {
      this.ladingStatusForm.get('date')!.clearValidators();
      this.ladingStatusForm.get('time')!.clearValidators();
      this.ladingStatusForm.get('timezone')!.clearValidators();
    }

    this.ladingStatusForm.get('date')!.updateValueAndValidity();
    this.ladingStatusForm.get('time')!.updateValueAndValidity();
    this.ladingStatusForm.get('timezone')!.updateValueAndValidity();

    this.setAutoselectedTimezone();
  }

  fetchTimezones() {
    const url = `/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`;
    this.http.get<any>(url).subscribe(response => {
      if (response.shipper?.address?.timezone_id) {
        const shipper_timezone = response.shipper.address.timezone_id;
        if (this.timezone_regions[shipper_timezone]) {
          this.timezone_regions[shipper_timezone] += ' - SHIPPER';
          this.shipper_timezone = shipper_timezone;
        }
      }
      if (response.consignee?.address?.timezone_id) {
        const consignee_timezone = response.consignee.address.timezone_id;
        if (this.timezone_regions[consignee_timezone]) {
          const suffix = this.shipper_timezone === consignee_timezone ? ', CONSIGNEE' : ' - CONSIGNEE';
          this.timezone_regions[consignee_timezone] += suffix;
          this.consignee_timezone = consignee_timezone;
        }
      }
      this.setAutoselectedTimezone();
    });
  }

  setAutoselectedTimezone() {
    const timezones = this.getOrderedTimezones();
    const currentTimezone = this.ladingStatusForm.get('timezone')!.value;
    if (!currentTimezone) {
      if (this.shipper_timezone || this.consignee_timezone) {
        this.ladingStatusForm.get('timezone')!.setValue(timezones[0]);
      } else {
        this.ladingStatusForm.get('timezone')!.setValue('America/Toronto');
      }
    }
    return timezones;
  }

  getOrderedTimezones() {
    const status = this.ladingStatusForm.get('status')!.value;
    if (status.includes('Shipper') && this.shipper_timezone) {
      return [this.shipper_timezone, ...Object.keys(this.timezone_regions).filter(tz => tz !== this.shipper_timezone)];
    } else if (status.includes('Consignee') && this.consignee_timezone) {
      return [this.consignee_timezone, ...Object.keys(this.timezone_regions).filter(tz => tz !== this.consignee_timezone)];
    } else {
      return Object.keys(this.timezone_regions);
    }
  }

  formatTimezoneString(timezone: string) {
    return timezone.replace('_', ' ').split('/').pop() || '';
  }

  getValue() {
    return this.ladingStatusForm.get('status')!.value;
  }

  isPopup(): boolean {
    return true;
  }

  onSave() {
    this.params.stopEditing();
  }

  onCancel() {
    this.params.api.stopEditing(true);
  }
}